//regex takes everything after /../../brandId_locale
//i.e. '../wcs/resources/mrp_gb/wishlist' --> /wishlist
export const getAPIUrl = (url, brandId) => {
    /* eslint-disable-next-line */
    const regex = new RegExp(`^.+\/${brandId}_\\w{2}\/`);
    return url?.replace(regex, '/');
};

export const getUnlocalisedUrl = url => {
    const locale = url.match(/^.*\/([a-z]{2})-([a-z]{2})\//)?.[0];
    return url.replace(locale, '/');
};
